export class ErrorModel {
  static defaultMessage = 'An error occured. Please contact Klayo support.';

  static Severity = Object.freeze({
    INFO: {},
    FAIL: {},
  });

  type: any;
  httpStatus: any;
  source: any;
  message: any;

  constructor(type: any, e: any, source?: any) {
    this.type = type;
    this.httpStatus = null;
    this.source = source;
    this.message = ErrorModel.parseServerError(e, this);
  }

  isFail() {
    return this.type === ErrorModel.Severity.FAIL;
  }

  static parseServerError(e: any, model?: any) {
    if (typeof e === 'object') {
      if (e.response) {
        if (model) model.httpStatus = e.response.status;

        const status = e.response.status;
        const data = e.response.data;
        const isAzureStopped =
          status === 403 && typeof data === 'string' && /Web app stopped/i.test(data);
        if ([502, 503, 504].includes(status) || isAzureStopped) {
          if (model) model.isNetworkError = true;
          return ErrorModel.defaultMessage;
        }

        if (e.response.data) {
          if (model) model.httpStatus = e.response.data.status;
          if (e.response.data.type !== undefined) {
            let errorMsg = '';
            if (e.response.data.errors)
              Object.values(e.response.data.errors).forEach((e: any) => {
                errorMsg += e[0] + '. ';
              });
            else errorMsg = e.response.data.title;
            return errorMsg;
          } else {
            const error = e.response.data;
            if (model) model.details = error.details;
            return error.errorMessage;
          }
        } else return ErrorModel.defaultMessage;
      } else {
        if (e.message === 'Network Error' && model) model.isNetworkError = true;
        return e.message;
      }
    } else if (typeof e === 'string') return e;
    else return ErrorModel.defaultMessage;
  }
}
